/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SingleTurnChatLanguageEnum } from './SingleTurnChatLanguageEnum';
import {
  SingleTurnChatLanguageEnumFromJSON,
  SingleTurnChatLanguageEnumFromJSONTyped,
  SingleTurnChatLanguageEnumToJSON,
} from './SingleTurnChatLanguageEnum';
import type { SingleTurnChatProtocolEnum } from './SingleTurnChatProtocolEnum';
import {
  SingleTurnChatProtocolEnumFromJSON,
  SingleTurnChatProtocolEnumFromJSONTyped,
  SingleTurnChatProtocolEnumToJSON,
} from './SingleTurnChatProtocolEnum';

/**
 *
 * @export
 * @interface SingleTurnChatInferencerCustomApiCreate
 */
export interface SingleTurnChatInferencerCustomApiCreate {
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerCustomApiCreate
   */
  name: string;
  /**
   *
   * @type {SingleTurnChatProtocolEnum}
   * @memberof SingleTurnChatInferencerCustomApiCreate
   */
  protocol: SingleTurnChatProtocolEnum;
  /**
   *
   * @type {SingleTurnChatLanguageEnum}
   * @memberof SingleTurnChatInferencerCustomApiCreate
   */
  language: SingleTurnChatLanguageEnum;
  /**
   *
   * @type {Date}
   * @memberof SingleTurnChatInferencerCustomApiCreate
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerCustomApiCreate
   */
  endpointUrl: string;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerCustomApiCreate
   */
  method: string;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerCustomApiCreate
   */
  requestTemplate: string;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof SingleTurnChatInferencerCustomApiCreate
   */
  responsePaths: { [key: string]: string };
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof SingleTurnChatInferencerCustomApiCreate
   */
  otherHeaders?: { [key: string]: string } | null;
  /**
   *
   * @type {number}
   * @memberof SingleTurnChatInferencerCustomApiCreate
   */
  credentialId?: number | null;
}

/**
 * Check if a given object implements the SingleTurnChatInferencerCustomApiCreate interface.
 */
export function instanceOfSingleTurnChatInferencerCustomApiCreate(
  value: object,
): value is SingleTurnChatInferencerCustomApiCreate {
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  if (!('language' in value) || value['language'] === undefined) return false;
  if (!('endpointUrl' in value) || value['endpointUrl'] === undefined) return false;
  if (!('method' in value) || value['method'] === undefined) return false;
  if (!('requestTemplate' in value) || value['requestTemplate'] === undefined) return false;
  if (!('responsePaths' in value) || value['responsePaths'] === undefined) return false;
  return true;
}

export function SingleTurnChatInferencerCustomApiCreateFromJSON(json: any): SingleTurnChatInferencerCustomApiCreate {
  return SingleTurnChatInferencerCustomApiCreateFromJSONTyped(json, false);
}

export function SingleTurnChatInferencerCustomApiCreateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SingleTurnChatInferencerCustomApiCreate {
  if (json == null) {
    return json;
  }
  return {
    name: json['name'],
    protocol: SingleTurnChatProtocolEnumFromJSON(json['protocol']),
    language: SingleTurnChatLanguageEnumFromJSON(json['language']),
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    endpointUrl: json['endpoint_url'],
    method: json['method'],
    requestTemplate: json['request_template'],
    responsePaths: json['response_paths'],
    otherHeaders: json['other_headers'] == null ? undefined : json['other_headers'],
    credentialId: json['credential_id'] == null ? undefined : json['credential_id'],
  };
}

export function SingleTurnChatInferencerCustomApiCreateToJSON(
  value?: SingleTurnChatInferencerCustomApiCreate | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    protocol: SingleTurnChatProtocolEnumToJSON(value['protocol']),
    language: SingleTurnChatLanguageEnumToJSON(value['language']),
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    endpoint_url: value['endpointUrl'],
    method: value['method'],
    request_template: value['requestTemplate'],
    response_paths: value['responsePaths'],
    other_headers: value['otherHeaders'],
    credential_id: value['credentialId'],
  };
}
